"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Retrieval = void 0;
var Experience_1 = require("./Experience");
var Knowledge_1 = require("./Knowledge");
var Retrieval = /** @class */ (function (_super) {
    __extends(Retrieval, _super);
    function Retrieval() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Retrieval";
        /**
         * Container element which collects all information static data
         */
        _this.knowledge = function (config) { return _this.push(function (registry) {
            var entity = new Knowledge_1.Knowledge();
            config(entity);
            return "knowledge { " + entity.render(registry) + " }";
        }); };
        /**
         * Container element which collects all information about runtime data
         */
        _this.experience = function (config) { return _this.push(function (registry) {
            var entity = new Experience_1.Experience();
            config(entity);
            return "experience { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Retrieval;
}(Array));
exports.Retrieval = Retrieval;
//# sourceMappingURL=Retrieval.js.map